export default "__VITE_ASSET__DZ7b9rhZ__"